export default __webpack_public_path__ + "static/media/thumbs-up-icon.dff5feba.svg";